import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './CookieBanner.css';

function CookieBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [hiding, setHiding] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('unimar_cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const dismiss = (choice) => {
    localStorage.setItem('unimar_cookie_consent', choice);
    setHiding(true);
    setTimeout(() => setVisible(false), 350);
  };

  if (!visible) return null;

  return (
    <div className={`cookie-banner${hiding ? ' cookie-banner--hiding' : ''}`} role="dialog" aria-label="Cookie consent">
      <div className="cookie-banner__inner">
        <div className="cookie-banner__text">
          <p className="cookie-banner__message">
            {t('cookie.message')} <strong>{t('cookie.accept')}</strong>{t('cookie.messageSuffix')}{' '}
            <a href="/cookie-policy" className="cookie-banner__link">{t('cookie.learnMore')}</a>
          </p>
        </div>
        <div className="cookie-banner__actions">
          <button className="cookie-banner__btn cookie-banner__btn--decline" onClick={() => dismiss('declined')}>
            {t('cookie.decline')}
          </button>
          <button className="cookie-banner__btn cookie-banner__btn--accept" onClick={() => dismiss('accepted')}>
            {t('cookie.accept')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieBanner;
